import type { Location } from "history";
import { createAction, createAsyncAction } from "./internal/platformActionCreators";

export enum NavigationActions {
  LOCATION_CHANGE = "@navigation/LOCATION_CHANGE",

  PAGE_DATA_REQUEST_START = "@navigation/PAGE_DATA_REQUEST_START",
  PAGE_DATA_REQUEST_SUCCESS = "@navigation/PAGE_DATA_REQUEST_SUCCESS",
  PAGE_DATA_REQUEST_ERROR = "@navigation/PAGE_DATA_REQUEST_ERROR",
}

export const navigationActions = {
  navigateToPath: createAction(
    NavigationActions.LOCATION_CHANGE,
    "Navigation",
    (newLocation: Location, oldLocation?: Location, forceRefresh?: boolean) => ({
      newLocation,
      oldLocation,
      forceRefresh,
    })
  ),
  pageDataRequest: createAsyncAction(
    "Navigation",
    NavigationActions.PAGE_DATA_REQUEST_START,
    (pageId: string) => ({ pageId }),
    NavigationActions.PAGE_DATA_REQUEST_SUCCESS,
    (pageId: string) => ({ pageId }),
    NavigationActions.PAGE_DATA_REQUEST_ERROR,
    (pageId: string, error: Error) => ({ pageId, error })
  ),
};
